import React from 'react'
import BaseFilter from './BaseFilter'
import PickUpCheckbox from './filter_components/checkboxes/PickUpCheckbox'
import ShippingCheckbox from './filter_components/checkboxes/ShippingCheckbox'
import LocationDisplay from './filter_components/LocationDisplay'

/**
 * Browse filter component showing delivery method options
 * and location-based filtering for pickup
 */
const BrowseFilter = () => {
  return (
    <BaseFilter layout='vertical'>
      <div className='flex flex-col md:flex-row md:items-center w-full'>
        <div className='w-auto mb-3 md:mb-0'>
          <div className='flex items-center space-x-4'>
            <ShippingCheckbox />
            <PickUpCheckbox />
          </div>
        </div>

        <div className='w-full md:w-auto flex-1 md:ml-6' style={{ maxWidth: '360px' }}>
          <LocationDisplay />
        </div>
      </div>
    </BaseFilter>
  )
}

export default BrowseFilter
